import { useState, useEffect } from "react";
import { fetchWordPressBooks } from "@/lib/wordpress";
import { Book } from "@/types/book";
import BookGrid from "@/components/BookGrid";
import CategoryFilter from "@/components/CategoryFilter";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Library = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [books, setBooks] = useState<Book[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBooks = async () => {
      setLoading(true);
      const fetchedBooks = await fetchWordPressBooks();
      setBooks(fetchedBooks);
      setLoading(false);
    };
    loadBooks();
  }, []);

  const categories = Array.from(new Set(books.map(book => book.category)));

  const filteredBooks = selectedCategory
    ? books.filter(book => book.category === selectedCategory)
    : books;

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 animate-fade-in">
          Browse Our Library
        </h1>
        <p className="text-center text-muted-foreground mb-12 animate-slide-up">
          Explore our collection of {books.length} eBooks across various categories
        </p>
        
        <CategoryFilter
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={setSelectedCategory}
        />
        
        {loading ? (
          <div className="text-center py-16">
            <p className="text-muted-foreground">Loading books...</p>
          </div>
        ) : (
          <BookGrid books={filteredBooks} />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Library;
